import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: 'pc-top-floor',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '楼层组排行',
          icon: 'el-icon-menu',
          content: {
            adImg: '',
            adLink: {},
            TabList: [{
              label: '胶带标签',
              goods_select: []
            }],
            topList: []
          },
          config: [{
            label: '广告图(174*540)',
            name: 'adImg',
            type: 'image',
            value: ''
          }, {
            label: '广告图链接',
            name: 'adLink',
            type: 'link',
            value: ''
          }, {
            label: '分组数据',
            name: 'TabList',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              link: {
                label: '链接',
                value: 'link'
              },
              goods_select: {
                label: '商品数据',
                value: []
              }
            }
          }, {
            label: '商品排行数据',
            name: 'topList',
            type: 'goods-select',
            value: []
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      tabs: 0,
      topList: [],
      goods: [[]]
    };
  },
  watch: {
    tabs: {
      handler: function handler(val) {
        this.getItem(val);
      }
    },
    'widgets.content.TabList': {
      handler: function handler(val, old) {
        if (old) {
          if (JSON.stringify(val) == JSON.stringify(old)) return;
        }
        var arr = [];
        if (val) {
          val.forEach(function (_) {
            arr.push([]);
          });
          this.goods = arr;
          this.getItem();
        }
      },
      immediate: true
    }
  },
  computed: {},
  created: function created() {
    var _this = this;
    var idList = this.widgets.content.topList;
    var ids = this.topList.map(function (item) {
      return item.id;
    });
    if (!this.isEqual(ids, idList)) {
      if (idList && idList.length) {
        this.apiPost('/bbb/goodsInfo/listData', {
          idList: idList,
          sortByParamId: true
        }).then(function (res) {
          _this.topList = res.data;
        });
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    getItem: function getItem() {
      var _this2 = this;
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'TabList';
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'goods';
      if (this.widgets.content[source].length) {
        var idList = this.widgets.content[source][index].goods_select;
        var ids = this[target][index].map(function (item) {
          return item.id;
        });
        if (!this.isEqual(ids, idList)) {
          if (idList && idList.length) {
            this.apiPost('/bbb/goodsInfo/listData', {
              idList: idList,
              sortByParamId: true
            }).then(function (res) {
              _this2.$set(_this2[target], index, res.data);
            });
          }
        }
      }
    }
  }
};